export const CUSTOMER_DISCOUNT_PERCENT = 5;

export const getProductDeal = (product) => {
  return (
    product?.deals?.find((d) => d.isActive) ||
    product?.Deals?.find((d) => d.IsActive) ||
    product?.productDeals?.find((d) => d.isActive) ||
    product?.ProductDeals?.find((d) => d.IsActive) ||
    product?.deals?.[0] ||
    product?.Deals?.[0] ||
    null
  );
};

export const getOrderItemUnitPrice = (item) => {
  const productPrice = Number(item?.product?.price || 0);
  const optionPrice = Number(item?.productOption?.extraPrice || 0);

  return optionPrice > 0 ? optionPrice : productPrice;
};

export const hasProductDeal = (product) => {
  const deal = getProductDeal(product);
  if (!deal) return false;

  const dealType = Number(deal.dealType ?? deal.DealType ?? 0);
  return dealType !== 0;
};

export const calculateOrderItemTotal = (item) => {
  const quantity = Number(item?.amount || 0);
  const unitPrice = getOrderItemUnitPrice(item);
  const product = item?.product;
  const deal = getProductDeal(product);

  if (!deal) {
    return unitPrice * quantity;
  }

  const dealType = Number(deal.dealType ?? deal.DealType ?? 0);
  const dealQuantity = Number(deal.quantity ?? deal.Quantity ?? 0);
  const dealPrice = Number(deal.dealPrice ?? deal.DealPrice ?? 0);
  const discountPercent = Number(
    deal.discountPercent ?? deal.DiscountPercent ?? 0
  );

  // 1 = 2+1 / 3+1 וכדומה
  if (dealType === 1 && dealQuantity > 0) {
    const groupSize = dealQuantity + 1;
    const fullGroups = Math.floor(quantity / groupSize);
    const remaining = quantity % groupSize;

    const paidItems = fullGroups * dealQuantity + remaining;
    return paidItems * unitPrice;
  }

  // 2 = כמות במחיר מיוחד, לדוגמה 2 ב-29.9
  if (dealType === 2 && dealQuantity > 0 && dealPrice > 0) {
    const fullGroups = Math.floor(quantity / dealQuantity);
    const remaining = quantity % dealQuantity;

    return fullGroups * dealPrice + remaining * unitPrice;
  }

  // 3 = אחוז הנחה על מוצר
  if (dealType === 3 && discountPercent > 0) {
    const priceAfterDiscount = unitPrice * (1 - discountPercent / 100);
    return priceAfterDiscount * quantity;
  }

  return unitPrice * quantity;
};

export const calculateOrderDiscountSummary = (order) => {
  const items = order?.ordersProducts || [];
  const user = order?.user;

  const isEligible = isUserEligibleForCustomerDiscount(user);

  let subtotal = 0;
  let discountableSubtotal = 0;

  items.forEach((item) => {
    const unitPrice = getOrderItemUnitPrice(item);
    const lineTotal = calculateOrderItemTotal(item);

    subtotal += lineTotal;

    const product = item?.product;
   const isOneShekelProduct = unitPrice === 1;
    const productHasDeal = hasProductDeal(product);

    // הנחת לקוח לא חלה על מוצר במבצע ולא על מוצר של שקל
    if (isEligible && !isOneShekelProduct && !productHasDeal) {
      discountableSubtotal += lineTotal;
    }
  });

  const discountAmount = isEligible
    ? discountableSubtotal * (CUSTOMER_DISCOUNT_PERCENT / 100)
    : 0;

  const finalTotal = subtotal - discountAmount;

  return {
    isEligible,
    subtotal,
    discountableSubtotal,
    discountPercent: CUSTOMER_DISCOUNT_PERCENT,
    discountAmount,
    finalTotal,
  };
};

export const isUserEligibleForCustomerDiscount = (user) => {
  return (
    user?.hasPermanentDiscount === true ||
    user?.HasPermanentDiscount === true ||
    user?.isEligibleForDiscount === true ||
    user?.hasDiscount === true ||
    user?.customerDiscount === true ||
    Number(user?.discountPercent || 0) > 0
  );
};

export const formatILS = (value) => {
  return `₪${Number(value || 0).toLocaleString("he-IL", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  })}`;
};